import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface TermsAcceptedSlice {
  termsAccepted?: boolean;
}

const initialState: TermsAcceptedSlice = {
  termsAccepted: undefined
} satisfies TermsAcceptedSlice;
const termsAcceptedSlice = createSlice({
  name: "termsAccepted",
  initialState,
  reducers: {
    setTermsAccepted(state, action: PayloadAction<boolean>) {
      state.termsAccepted = action.payload;
    }
  },
  selectors: {
    selectedTermsAccepted(state) {
      return state.termsAccepted;
    }
  }
});

export const { setTermsAccepted } = termsAcceptedSlice.actions;
export const { selectedTermsAccepted } = termsAcceptedSlice.selectors;
export default termsAcceptedSlice.reducer;
